import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Table from 'react-bootstrap/Table';
import Const from '../../../util/Constants';
import MassMailAPI from '../../../api/MassMailAPI';
import ApiUiController from '../../../controller/ApiUiController';
import Display from '../../../util/Display';
import withRouter from '../../../util/WithRouter';
import Util from '../../../util/Util';

class Settings extends React.Component {

  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).mass_mail;
    this.id = parseInt(props.match.params.id);
    this.data = {};
    this.state = { inApiCall: true };
  }

  componentDidMount() { MassMailAPI.get(this.id, this.onReceived, this.onFail); }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = res => {
    this.data = res;
    this.setState({ ...this.state, inApiCall: false });
  };

  render() {
    const data = this.data;
    const fields = this.model.fields;
    return (
      <ApiUiController inApiCall={this.state.inApiCall}>
        <section className="pt-4 pb-5">

          <div className="container pt-3">
            <div className="row">
              <div className="col-md-12">
                <Table stripped bordered hover size="md">
                  <thead>
                    <tr>
                      <th>{fields.name.label_name}</th>
                      <th>{fields.template.label_name}</th>
                      <th>{fields.config.label_name}</th>
                      <th>{fields.operation_status.label_name}</th>
                      <th>{fields.created_by.label_name}</th>
                      <th>{fields.created_date.label_name}</th>

                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{Display.FieldValue(data, 'name', fields)}</td>
                      <td>{Display.FieldValue(data, 'template', fields)}</td>
                      <td>{Display.FieldValue(data, 'config', fields)}</td>
                      <td>{Display.FieldValue(data, 'operation_status', fields)}</td>
                      <td>{Display.FieldValue(data, 'created_by', fields)}</td>
                      <td>{Display.FieldValue(data, 'created_date', fields)}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>

          <div className="container pt-4">
            <div className="row">
              <div className="col-md-6">
                <Table stripped bordered hover size="md">
                  <tbody>
                    <tr>
                      <td>Send</td>
                      <td>100</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Delivered</td>
                      <td>80</td>
                      <td>80%</td>
                    </tr>
                    <tr>
                      <td>Bounce</td>
                      <td>20</td>
                      <td>20%</td>
                    </tr>
                    <tr>
                      <td>Opens</td>
                      <td>60</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Unique Open</td>
                      <td>20</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Clicks</td>
                      <td>350</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Unique Clicks</td>
                      <td>20</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Invalid Emails</td>
                      <td>20</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Spam Reports</td>
                      <td>20</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Unsubscribe</td>
                      <td>2</td>
                      <td></td>
                    </tr>

                  </tbody>
                </Table>
              </div>
              <div className="col-md-6">
                <div className="help-div">

                  <ol>
                    <h4>Help</h4>
                    <li><a href="https://docs.sendgrid.com/ui/sending-email/bounces" target="_blank" rel="noreferrer">https://docs.sendgrid.com/ui/sending-email/bounces</a></li>
                    <li><a href="https://sendgrid.com/blog/understanding-email-metrics/" target="_blank" rel="noreferrer">https://sendgrid.com/blog/understanding-email-metrics/</a></li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </section>
      </ApiUiController>
    );
  }
}
export default withRouter(Settings);